import React from 'react'
import type { ReactNode } from 'react'
import { TooltipPopOver } from '../TooltipPopOver'

export type DisabledReasonPopOverProps = {
  /** Why the control is blocked — absent when the control is usable, and then the children render untouched. */
  reason?: string
  children: ReactNode
}

/**
 * Shows a blocked control's reason on hover. The block `span` carries the tooltip because a disabled
 * control takes no pointer events (`webui-component-usage-guide.md` → "Blocked control").
 */
export const DisabledReasonPopOver = ({ reason, children }: DisabledReasonPopOverProps) =>
  reason ? (
    <TooltipPopOver tooltipBody={reason}>
      <span className="d-block">{children}</span>
    </TooltipPopOver>
  ) : (
    children
  )
